import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap';
import { AppConfigService } from '../../app.config';
import { DisplayModes } from '../../models/enums';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { AppTranslationService } from '../../services/app-translation.service';
import { VisitChannelsService } from './visit-channels.service';

@Component({
  selector: 'crm-visit-channels',
  templateUrl: './visit-channels.component.html',
  styleUrls: ['./visit-channels.component.css']
})
export class VisitChannelsComponent implements OnInit {

  visitChannels: any[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  searchText: string;
  pageSize: number;
  public logo = require("../../../app/assets/images/demo/Icon_Items Format.png");

  selectedVisitChannelId;
  addNew: boolean = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;
  constructor(private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService,
    private readonly appConfig: AppConfigService,
    private readonly visitChannelsService: VisitChannelsService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.getVisitChannels();
  }

  getVisitChannels() {
    this.displayMode = DisplayModes.Loading;
    this.visitChannelsService.search(this.searchText).subscribe(responce => {
      this.visitChannels = responce as any[];
      this.displayMode = DisplayModes.Success;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get visitChannels');
        console.log(err);
      })

  }

  gotoNew() {
    this.addNew = true;
  }

  edit(id) {
    this.selectedVisitChannelId = id;
    this.addNew = true;
  }

  confirmDelete(visitChannel) {
    this.selectedVisitChannelId = visitChannel;
    this.deleteModal.show();
  }

  delete() {
    this.hideDeleteModal();
    this.displayMode = DisplayModes.Loading;
    this.visitChannelsService.delete(this.selectedVisitChannelId.id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("clm.deletedSuccessfully"), MessageSeverity.Success);

      let index = this.visitChannels.indexOf(this.selectedVisitChannelId);
      this.visitChannels.splice(index, 1);
    }, error => {
      this.displayMode = DisplayModes.Error;
      this.alertService.showStickyMessage("Save Error", "The below errors occured while delete item fromat:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });
  }

  get canManageVisitChannels() {
    return this.accountService.userHasPermission(Permission.manageVisitChannelsPermission);
  }

  closeAdding(event) {
    this.selectedVisitChannelId = undefined;
    this.addNew = false;
    if (event) {
      this.getVisitChannels();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

}
